import baustein from "baustein";
import template from "templates/modules/product/monoprice_buy_area";


export const AFFILIATE_BUY_BUTTON_SELECTOR = ".monoprice-buy-area__buy-button--affiliate";

export default baustein.register("monoprice-buy-area", {
    template,

    getInitialRenderContext() {
        return {
            monoprice_buy_area: {
                buy_option: {
                    promotions: [],
                },
                is_saved_for_later: false,
                affiliate_lead_url: "",
            },
        };
    },

    onInsert() {
        const buyButton = this.el.querySelector(AFFILIATE_BUY_BUTTON_SELECTOR);

        if (buyButton) {
            const initialLeadUrl = buyButton.href;
            this._setAffiliateLeadLink(initialLeadUrl);
        }
    },

    /**
     * Sets the affiliate lead link on the buy button.
     *
     * @params {String} leadUrl - The affiliate lead URL.
     */
    _setAffiliateLeadLink(leadUrl) {
        this.el.querySelector(AFFILIATE_BUY_BUTTON_SELECTOR).href = leadUrl;
        const leadLinkComponent = this.findComponent("lead-link");

        if (leadLinkComponent) {
            leadLinkComponent.updateUrl();
        }
    },
});
